export default {"src":"/_next/static/image/public/images/ic_video_call.d4f3bd83842ef4f761e70002593bdaad.svg","height":54,"width":54};